import { useMemo } from 'react';
import { Avatar, Spinner, Tooltip } from '@chakra-ui/react';
import { StringToColor } from '@/utils/helpers/color.helper';

type Props = {
  username: string;
  variant?: 'md' | 'lg' | 'sm' | 'xs';
};

// NOTE: we can't use { createHash } from 'crypto' because we are in a browser context
// so creating a simpleHash func that gives us a random consistent string per user
function simpleHash(str: string) {
  let hash = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = (hash * 0x01000193) >>> 0; // >>> 0 forces unsigned 32-bit
  }
  return hash.toString(16).padStart(8, '0');
}

export const UserIcon = ({ username, variant = 'sm' }: Props) => {
  const hashedUsername = useMemo(() => {
    return simpleHash(username);
  }, [username]);

  if (!username) {
    return <Spinner />;
  }

  const getInitials = (name: string) => {
    // TODO: review this rule to use the first letter and the last number if the last char is a number
    // be sure to remove email part
    let displayName = name.toUpperCase().split('@')[0];

    if (displayName.includes('IPAD')) displayName = displayName.split('IPAD')[1];
    else if (displayName.includes('BAYER')) displayName = `${displayName.split('BAYER')[1]}`;
    else if (displayName.includes('NOVO')) displayName = `${displayName.split('NOVO')[1]}`;
    else if (displayName.includes('P01')) displayName = `${displayName.split('P01')[1]}`;
    else if (displayName.includes('P02')) displayName = `${displayName.split('P02')[1]}`;
    else if (displayName.includes('H01')) displayName = `H${displayName.split('H010')[1]}`;
    else if (displayName.includes('H02')) displayName = `H${displayName.split('H020')[1]}`;
    else displayName = displayName.substring(0, 2);
    return displayName;
  };

  return (
    <Tooltip label={username}>
      <Avatar
        color="#FFF"
        name={username}
        getInitials={getInitials}
        backgroundColor={StringToColor(hashedUsername)}
        size={variant}
      ></Avatar>
    </Tooltip>
  );
};

export default UserIcon;
